<template>
  <div class="acomodar">
    <SpinnerCarga class="container" v-if="Spinner" />
    <Renovacion v-else />
  </div>
</template>

<script>
import SpinnerCarga from "@/components/ModContratos/Spinner/Spinner.vue";
import Renovacion from "@/components/ModContratos/RegRenovacion/RegRenIndividual.vue";
import { mapGetters , mapActions} from "vuex";
export default {
  name: "SolimanologRenovacionIndividual",
  components: {
    Renovacion,
    SpinnerCarga,
  },

  data() {
    return {};
  },

  mounted() {},
  computed: {
    ...mapGetters("renovaciones", ["Spinner"]),
  },

  created(){
    this.cambiarEstadoNavbar()
    this.Renovaciones()
  },

  methods: {
    ...mapActions("renovaciones", ["Renovaciones"]),


    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch('acciones/CambioNavbar', true);
    },
  },
};
</script>
